package net.gorillagroove.db

import com.squareup.sqldelight.ColumnAdapter
import kotlin.Any
import kotlin.Boolean
import kotlin.Long
import kotlin.String
import kotlin.collections.Map
import net.gorillagroove.api.UserNotificationId
import net.gorillagroove.notification.RawUserNotificationType
import net.gorillagroove.util.Instant

public data class DbUserNotification(
  public val id: UserNotificationId,
  public val message: String,
  public val read: Boolean,
  public val createdAt: Instant,
  public val updatedAt: Instant,
  public val deleted: Boolean,
  public val synchronized: Boolean,
  public val type: RawUserNotificationType,
  public val data_: Map<String, Any>
) {
  public override fun toString(): String = """
  |DbUserNotification [
  |  id: $id
  |  message: $message
  |  read: $read
  |  createdAt: $createdAt
  |  updatedAt: $updatedAt
  |  deleted: $deleted
  |  synchronized: $synchronized
  |  type: $type
  |  data_: $data_
  |]
  """.trimMargin()

  public class Adapter(
    public val idAdapter: ColumnAdapter<UserNotificationId, Long>,
    public val createdAtAdapter: ColumnAdapter<Instant, Long>,
    public val updatedAtAdapter: ColumnAdapter<Instant, Long>,
    public val typeAdapter: ColumnAdapter<RawUserNotificationType, String>,
    public val data_Adapter: ColumnAdapter<Map<String, Any>, String>
  )
}
